import useMediaQuery from '@utility/hooks/useMediaQuery';
import { motion, useInView, Variants } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';

interface Props extends PropsWithChildren {
  readonly className?: string;
  readonly mobileOffset?: number;
  readonly desktopOffset?: number;
  readonly element?: 'section' | 'div';
}

const AnimateInView = ({
  children,
  className,
  element = 'section',
  mobileOffset = 0.2,
  desktopOffset = 0.5,
}: Props) => {
  const ref = useRef(null);
  const isMobile = useMediaQuery(752);
  const inView = useInView(ref, {
    amount: isMobile ? mobileOffset : desktopOffset,
    once: true,
  });

  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        duration: isMobile ? 0.3 : 0.5,
        type: 'spring',
        stiffness: 50,
        damping: 14,
      },
    },
  };

  const MotionElement = motion[element];

  return (
    <MotionElement
      ref={ref}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={containerVariants}
      className={className}
    >
      {children}
    </MotionElement>
  );
};

export default AnimateInView;
